'use client'

import { Avatar, styled } from '@mui/material'

const StyledAvatar = styled(Avatar)({
  width: 30,
  height: 30,
})

export default function FilterAvatar({
  name,
  src,
}: {
  name: string
  src: string
}) {
  return (
    <div className="flex flex-row items-center justify- gap-3">
      <StyledAvatar alt={name} src={src} />
      <span>{name}</span>
    </div>
  )
}
